import api from '../api/instance';

import { TestDataSet, Page } from '@testsigma/organism';
import { PrivateURLConstants } from '@constants/private-url.constant';
const nameSpace = PrivateURLConstants.TEST_DATA_SETS;

const findAll = (
  query?: string,
  sort?: string,
  size?: number,
  page?: number,
) => {
  return api
    .get(nameSpace, {
      query,
      size,
      page,
      sort,
    })
    .then((res) => new Page<TestDataSet>().deserialize(res, TestDataSet))
    .catch((e) => Promise.reject(e));
};

const show = (dataSetId: number) => {
  return api
    .get(nameSpace + '/' + dataSetId)
    .then((res) => new TestDataSet().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const bulkDestroy = (ids: number[], applicationVersionId: number) => {
  return api
    .remove(`${nameSpace}/bulk?${`ids[]`}=${ids.join()}&applicationVersionId=${applicationVersionId}`)
    .then((res) => res)
    .catch((e) => Promise.reject(e));
};

const TestDataSetService = {
  findAll,
  show,
  bulkDestroy,
};

export default TestDataSetService;
